import { AUTH_TOKEN_KEYS } from 'app/constants/app';

export function getAuthToken(entity: TAuthTokenEntity) {
  const token = localStorage.getItem(AUTH_TOKEN_KEYS[entity]);

  return token;
}
